import React, { useState, useCallback, useEffect, useRef } from "react";
import styled from "styled-components";
import Modal from "./modal";
import FormTitle from "../formTitle";
import Button from "../button";
import logger from "utils/logger";

const StyledConfirmModal = styled.div`
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 30px;
  outline: none;
`;

const StyledConfirmContent = styled.div`
  color: ${({ theme }) => theme.fontColor};
  letter-spacing: 1px;
  font-size: ${({ theme }) => theme.lsmall};
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 3px;
`;

const StyledButtonGroup = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const StyledMessage = styled.div`
  padding: 3px 0;
  opacity: ${({ show }) => (show ? 1 : 0)};
  color: ${({ theme }) => theme.weakRed};
  font-size: ${({ theme }) => theme.fontSize.lsmall};
  height: ${({ theme }) => theme.fontSize.lsmall};
`;

const ConfirmModal = ({
  errorMessage,
  visible,
  onClose,
  title,
  content,
  onConfirm = () => console.log("确认"),
  onCancel = () => console.log("取消"),
  confirmLabel = "确认",
  cancelLabel = "取消",
  confirmType = "normal",
}) => {
  const cRef = useRef(null);

  useEffect(() => {
    if (visible) {
      cRef.current && cRef.current.focus();
      logger.log("聚焦confirm");
    }
  }, [visible]);

  return (
    <Modal visible={visible} onClose={onClose}>
      <StyledConfirmModal
        tabIndex={1}
        ref={cRef}
        onKeyUp={(e) => {
          logger.log(e);
          e.preventDefault();
          //阻止事件进一步传播
          e.stopPropagation();
          switch (e.keyCode) {
            //回车 确认
            case 13:
              console.log("确认");
              onConfirm && onConfirm();
              break;
            //Esc 取消
            case 27:
              console.log("取消");
              onCancel && onCancel();
              break;
            default:
              return;
          }
        }}
      >
        <FormTitle>{title}</FormTitle>
        <StyledConfirmContent>
          {content}
          <StyledMessage show={!!errorMessage}>{errorMessage}</StyledMessage>
        </StyledConfirmContent>
        <StyledButtonGroup>
          <Button type={confirmType} onClick={onConfirm}>
            {confirmLabel}
          </Button>
          <Button onClick={onCancel}>{cancelLabel}</Button>
        </StyledButtonGroup>
      </StyledConfirmModal>
    </Modal>
  );
};

export default ConfirmModal;
